import { IRequesterInfo } from "../../../../base/models"
import { ClientProxy } from "../../../../base/proxy/clientProxy"

export class OpenTicketApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/jira/openTicket',
      requesterInfo,
    })
  }

  public async openTicket(request: any): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
